import { Component, OnInit, Input, NgModule, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { InfoB } from '@app/models/infobox';
import { CommonModule } from '@angular/common';
import { CssBackgroundImageProxyModule } from '@app/directives/css-background-image-proxy.directive';
import { LinkModule } from '@app/directives/link.directive';

@Component({
  selector: 'app-picture',
  templateUrl: './picture.component.html',
  styleUrls: ['./picture.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PictureComponent implements OnInit {
  _box: InfoB;

  @Input() set box(value) {
    this._box = value;
    this.cdr.markForCheck();
  }

  @Input() styleClasses: string | string[] | Set<string> | { [klass: string]: any; };
  @Input() customStyle: { [klass: string]: any; };
  @Input() isAreaHero: boolean;
  constructor(private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

  }

  getBannerBackGround() {
   const bannerBackGround = {
      'background-color': this._box.TextBackgroundBanner,
      'width': '100%' ,
      'padding-top': '20px' ,
      'padding-bottom': '20px'
    };

   return bannerBackGround;
  }

}
@NgModule({
  declarations: [PictureComponent],
  exports: [PictureComponent],
  imports: [
    CommonModule,
    CssBackgroundImageProxyModule,
    LinkModule,
  ]
})
export class PictureInfoboxModule { }
